module.exports = __webpack_public_path__ + "img/Body_DiffuseColor.d01185c.png";